import { ChannelTypeEnum } from "../types";
import {
  WECHAT_ACCOUNT_WS_ADDRESS,
  WECHAT_CHAT_WS_ADDRESS,
  WECHAT_CONTACT_WS_ADDRESS,
} from "../constants";
import { wsHandler } from "../handler/wechat/ws-handler";
import chatSdkHooks from "../hooks";
import { WebSocketClient } from "./ws";

export const wechatAccountWsClient = new WebSocketClient({
  wsAddress: WECHAT_ACCOUNT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Wechat,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Wechat,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const wechatChatWsClient = new WebSocketClient({
  wsAddress: WECHAT_CHAT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Wechat,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Wechat,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const wechatContactWsClient = new WebSocketClient({
  wsAddress: WECHAT_CONTACT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.Wechat,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.Wechat,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});
